// extracted by mini-css-extract-plugin
export default {"Component":"AppAspectRatio_Component__HX9ib","Content":"AppAspectRatio_Content__5Q+rt"};